import React from 'react';
import { motion } from 'framer-motion';
import { CalendarHeartIcon, SparklesIcon, MapPinIcon, HeartIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
const steps = [{
  icon: SparklesIcon,
  number: '01',
  titleKey: 'howWeWork.s1t',
  descriptionKey: 'howWeWork.s1d'
}, {
  icon: CalendarHeartIcon,
  number: '02',
  titleKey: 'howWeWork.s2t',
  descriptionKey: 'howWeWork.s2d'
}, {
  icon: MapPinIcon,
  number: '03',
  titleKey: 'howWeWork.s3t',
  descriptionKey: 'howWeWork.s3d'
}, {
  icon: HeartIcon,
  number: '04',
  titleKey: 'howWeWork.s4t',
  descriptionKey: 'howWeWork.s4d'
}];
export function HowWeWork() {
  const {
    t
  } = useLanguage();
  return <section id="como-trabajamos" className="py-16 sm:py-24 lg:py-32 px-5 sm:px-8 lg:px-24 bg-ivory w-full overflow-hidden" data-id="element-205" data-mp="3ghiixbkx5y6f">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 1.2,
      ease: [0.22, 1, 0.36, 1]
    }} className="text-center max-w-3xl mx-auto mb-12 sm:mb-16 lg:mb-24" data-id="element-206" data-mp="1epn8t0eba1qb">
        <p className="uppercase tracking-[0.3em] text-olive text-[9px] sm:text-[10px] font-semibold mb-4 sm:mb-6" data-id="element-207" data-mp="2ibheu8x6h94z">
          {t('howWeWork.tag')}
        </p>
        <h2 className="font-display text-fluid-h2 text-volcanic font-light leading-[1.1]" data-id="element-208" data-mp="1unzw12vw5le5">
          {t('howWeWork.title1')} <br data-id="element-209" data-mp="23mtku72zd7h5" />
          <span className="font-script text-fluid-script text-terracotta inline-block mt-[-0.1em]" data-id="element-210" data-mp="23ncvr3u7qvlo">
            {t('howWeWork.title2')}
          </span>
        </h2>
      </motion.div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-10 max-w-[1400px] mx-auto" data-id="element-211" data-mp="3f1qejua40kuu">
        {steps.map((step, index) => {
        const Icon = step.icon;
        return <motion.div key={step.number} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 1,
          delay: index * 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="group relative bg-sand p-6 sm:p-8 lg:p-12 border border-beige hover:border-terracotta/30 transition-colors duration-500 rounded-sm w-full" data-id="element-212" data-mp="27prbu0gmfb7o" data-mpi={index}>
              <div className="flex items-start justify-between mb-6 sm:mb-10" data-id="element-213" data-mp="1xxv03mlm3mkz">
                <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-ivory flex items-center justify-center text-terracotta shadow-sm group-hover:bg-terracotta group-hover:text-ivory transition-colors duration-500 flex-shrink-0" data-id="element-214" data-mp="22rpk6r54q3kl">
                  <Icon size={20} strokeWidth={1.2} className="sm:w-6 sm:h-6 w-5 h-5" data-id="element-215" data-mp="12qcbxbeb80ea" />
                </div>
                <span className="font-display italic text-3xl sm:text-4xl text-volcanic/20 group-hover:text-terracotta/40 transition-colors duration-500" data-id="element-216" data-mp="sseo2p0d45m7">
                  {step.number}
                </span>
              </div>
              <h3 className="font-display text-2xl sm:text-3xl text-volcanic mb-3 sm:mb-4 leading-tight font-light" data-id="element-217" data-mp="js00tk3u8gg2">
                {t(step.titleKey)}
              </h3>
              <p className="text-[13px] sm:text-[14px] leading-relaxed text-volcanic/80 font-light" data-id="element-218" data-mp="a1wyuueqns5l">
                {t(step.descriptionKey)}
              </p>
            </motion.div>;
      })}
      </div>
    </section>;
}